import {Modal} from 'quickstart/components/layout/Modal'
import {AuthView} from 'quickstart/components/tizra/Auth'
import {useCallback, useState} from 'react'

export type SignInModalView = Exclude<AuthView, 'changePassword'>

/**
 * Augment useModalStore to accept defaultView, and return an augmented state
 */
export const useSignInModalProps = ({
  defaultView = 'signin',
  ...options
}: Parameters<typeof Modal.useStore>[0] & {
  defaultView?: SignInModalView
} = {}) => {
  const store = Modal.useStore(options)
  const [view, setView] = useState<SignInModalView>(defaultView)

  // Modified show() accepts a view
  const show = useCallback<(v?: SignInModalView) => void>(
    v => {
      setView((typeof v === 'string' && v) || 'signin')
      store.show()
    },
    [store],
  )

  // Augmented state includes current view
  return {store: {...store, show}, view}
}
